/**
 * Sanitizes a string for use as a filename — replaces spaces with underscores
 * and removes characters that could break file systems.
 */
export const sanitizeFilename = (name) => {
  const sanitized = name
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_\-À-ÿ]/g, '');
  return sanitized || 'download';
};

/**
 * Downloads a Blob as a file with the given filename.
 * Uses a temporary <a> element with the download attribute
 * instead of window.open, which produces "unknown.pdf".
 */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 100);
};
